import { render, staticRenderFns } from "./porposal-pending-report-evaluations.vue?vue&type=template&id=6e7fdb49&"
import script from "./porposal-pending-report-evaluations.vue?vue&type=script&lang=ts&"
export * from "./porposal-pending-report-evaluations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports